import React from 'react';
import { Reveal } from './Reveal';
import { bonuses, bonusesTotalValue } from '../data/offer';
export function BonusesSection() {
  return <section id="bonus" className="scroll-mt-24 bg-brand-dark px-4 py-20 md:py-28" data-id="element-27" data-mp="gxgdpshbkhf3">
      <Reveal className="mx-auto max-w-3xl" data-id="element-28" data-mp="vtnvyn9638rq">
        <div className="mb-12 text-center" data-id="element-29" data-mp="qtt5gktb0l77">
          <div className="inline-flex rounded-full bg-brand-green/15 px-4 py-2 text-[10px] font-extrabold tracking-[0.14em] text-brand-green" data-id="element-30" data-mp="qsrxip7l4etp">
            INCLUSI GRATIS OGGI
          </div>
          <h2 className="mt-4 text-3xl font-black text-brand-deep md:text-4xl" data-id="element-31" data-mp="ztg97d9ia33f">🎁 5 Bonus Esclusivi</h2>
          <p className="mx-auto mt-4 max-w-xl text-brand-gray" data-id="element-32" data-mp="1eicex3o3b40v">
            Valore reale <span className="font-bold text-brand-green line-through" data-id="element-33" data-mp="19jrep48u8kcf">{bonusesTotalValue}</span> — inclusi
            senza costo aggiuntivo, solo per un tempo limitato.
          </p>
        </div>
        <div className="space-y-3" data-id="element-34" data-mp="1jj0eweuaqv78">
          {bonuses.map((bonus, index) => <article key={bonus.title} className="flex items-center gap-4 rounded-2xl border border-brand-deep/[0.06] bg-brand-alt p-4 shadow-sm sm:gap-5" data-id="element-35" data-mp="3pqbrz8csaqzj" data-mpi={index}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-deep font-serif font-bold text-white" data-id="element-36" data-mp="2lm5d1zyicki">
                {index + 1}
              </span>
              <img src={bonus.image} alt={`Copertina di ${bonus.title}`} loading="lazy" className="h-20 w-14 shrink-0 rounded-md border border-brand-dark object-cover shadow-sm sm:h-24 sm:w-[4.25rem]" data-id="element-37" data-mp="7icl1o7un65e" />
              <div className="min-w-0 flex-1" data-id="element-38" data-mp="lcvnfznsm9np">
                <h3 className="font-bold leading-snug text-brand-deep" data-id="element-39" data-mp="qbq5v0hulw7a">{bonus.title}</h3>
                <p className="mt-1 text-xs" data-id="element-40" data-mp="vajmh1sfm3bo">
                  <span className="text-brand-gray" data-id="element-41" data-mp="vbur13tpbf3u">{bonus.description}</span>
                  <span className="ml-2 inline-flex rounded-full bg-brand-green/10 px-2 py-0.5 font-extrabold text-brand-green" data-id="element-42" data-mp="10afr938ydysa">
                    VALORE {bonus.price}
                  </span>
                  <span className="ml-2 font-extrabold text-brand-amber" data-id="element-43" data-mp="5mxfwvhyu0zs">GRATIS</span>
                </p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}